module.exports = __webpack_public_path__ + "img/thermometer.a5cb4226.svg";